<template>
  <div class="RouteContainer">
    <app-gallery-section :sectionIndex="2"/>
  </div>
</template>

<script>
import appGallerySection from './../gallery/gallery-section'

export default {
  name: 'socialBehavior',

  components: {
    appGallerySection
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/social-behavior.vue